import React from "react";

export default function Loader({isInline}) {
  if (isInline) {
    return (
      <div className="spinner-container-small">
        <div className="loading-spinner-small">
        </div>
      </div>
    );
  }

  return (
    <div id="overlay" className="show">
      <div className="spinner-container">
        <div className="loading-spinner">
        </div>
        <div className="spinner-text">Processing. Please do not refresh the page.</div>
      </div>
    </div>
  );
}
